export const TRIAL_CONFIG = {
  // Trial limits
  ENTRY_LIMIT: 5,
  
  // Time periods (in months)
  TRIAL_DURATION_MONTHS: 3,
  GRACE_PERIOD_MONTHS: 3,
  
  // Important dates
  LEGACY_CUTOFF_DATE: '2025-08-01T00:00:00Z',
  LEGACY_DELETION_DATE: '2025-11-01T00:00:00Z'
};